// todo add mapping for statuses and get all colors from Nik
import type { FC } from 'react'
import React from 'react'
import { makeStyles, createStyles } from '@material-ui/core/styles'
import clsx from 'clsx'

import type { ITheme } from '@homeviews/styles'

const useStyles = makeStyles((theme: ITheme) =>
  createStyles({
    root: {
      display: 'flex',
    },
    step: {
      display: 'flex',
      alignItems: 'center',
      marginRight: 15,
    },
    stepNo: {
      border: '1px solid rgba(130,139,151,0.5)',
      backgroundColor: 'rgba(0,192,150,0)',
      width: 26,
      height: 26,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: '50%',
      marginRight: 6,
      color: theme.colors.grey450,
    },
    stepLabel: {
      color: theme.colors.grey450,
      fontSize: 16,
      lineHeight: '23px',
    },
    stepActive: {
      '& span:first-child': {
        border: `1px solid #000433`,
        color: '#000433',
        fontWeight: 500,
      },
      '& span:last-child': {
        color: theme.colors.grey600,
      },
    },
  }),
)

interface IStep {
  step: number
  label: string
}

interface IProps {
  className?: string
  currentStep: number
  steps: IStep[]
}

const Stepper: FC<IProps> = ({ className, currentStep, steps }) => {
  const classes = useStyles()

  return (
    <div className={clsx(classes.root, className)}>
      {steps.map((step: IStep) => (
        <div
          className={clsx(
            classes.step,
            currentStep === step.step && classes.stepActive,
          )}
          key={step.step}
        >
          <span className={classes.stepNo}>{step.step}</span>
          <span className={classes.stepLabel}>{step.label}</span>
        </div>
      ))}
    </div>
  )
}

export default Stepper
